import _ from 'lodash'
import type {DecorationPluginFunction} from '../../types'
import type {CoreExportFormat} from '@wix/document-services-types'

export const deepSort = (value: any): any => {
    if (_.isPlainObject(value)) {
        const sortedObj = _.mapValues(value, prop => deepSort(prop))
        return Object.fromEntries(Object.entries(sortedObj).sort(([a], [b]) => a.localeCompare(b)))
    } else if (_.isArray(value)) {
        return _.map(value, prop => deepSort(prop))
    }

    return value
}

export const pack: DecorationPluginFunction = (componentExport: CoreExportFormat) => {
    _.forOwn(componentExport, (prop, key) => {
        ;(componentExport as Record<string, any>)[key] = deepSort(prop)
    })
}
